import React, { useEffect, useState } from 'react';
import {
  Box,
  Drawer,
  IconButton,
  useMediaQuery,
  Typography,
} from '@mui/material';
import { Menu } from '@mui/icons-material';
import { Navigate, useLocation } from 'react-router-dom';
import TopNav from '../v2/TopNav/TopNav';
import { decodeToken } from '../utils/settings';

const GlobalWrapper = ({
  children,
  SidebarComponent = null,
  sidebarProps = {},
  sidebarTitle = 'Sidebar',
  style = {},
}) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const pwaJwt = searchParams.get('token');
  if (pwaJwt) {
    localStorage.setItem('token', pwaJwt);
  }

  const token = localStorage.getItem('token');
  const [tokenData, setTokenData] = useState({});
  const getTokenData = async () => {
    const decoded = await decodeToken();
    setTokenData(decoded);
  };
  useEffect(() => {
    getTokenData();
  }, []);
  let isPwa = false;

  if (tokenData && tokenData?.pwa_module) {
    isPwa = true;
  }
  console.log(tokenData);

  const isMobile = useMediaQuery('(max-width: 899px)');
  const [open, setOpen] = useState(false);

  const toggleDrawer = () => {
    setOpen(!open);
  };
  if (!token) {
    return <Navigate to='/' />;
  }

  if (isPwa) {
    return (
      <>
        {tokenData &&
          tokenData?.pwa_module_config &&
          tokenData?.pwa_module_config?.isShowHeader && <TopNav />}
        <Box
          sx={{ display: 'flex', flexDirection: { xs: 'column', lg: 'row' } }}
        >
          {tokenData?.pwa_module_config?.isShowSidebar &&
            SidebarComponent &&
            isMobile && (
              <>
                <IconButton
                  sx={{ position: 'relative' }}
                  onClick={toggleDrawer}
                >
                  <Box
                    sx={{
                      width: '100%',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <Menu sx={{ mr: 2 }} />
                    <Typography variant='h6'>{sidebarTitle}</Typography>
                  </Box>
                </IconButton>
                <Drawer
                  anchor='left'
                  open={open}
                  onClose={toggleDrawer}
                >
                  <SidebarComponent {...sidebarProps} />
                </Drawer>
              </>
            )}
          {tokenData?.pwa_module_config?.isShowSidebar &&
            SidebarComponent &&
            !isMobile && (
              <>
                <Box sx={{ width: '18%', height: '100vh', overflowY: 'auto' }}>
                  {SidebarComponent && <SidebarComponent {...sidebarProps} />}
                </Box>
              </>
            )}
          <Box
            sx={{
              width: isMobile || !SidebarComponent ? '100%' : '82%',
              height: '100vh',
              overflowY: 'auto',
            }}
          >
            {children}
          </Box>
        </Box>
      </>
    );
  }
  return (
    <>
      <TopNav />
      <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' } }}>
        {SidebarComponent && isMobile && (
          <>
            <IconButton
              sx={{ position: 'relative' }}
              onClick={toggleDrawer}
            >
              <Box
                sx={{ width: '100%', display: 'flex', alignItems: 'center' }}
              >
                <Menu sx={{ mr: 2 }} />
                <Typography variant='h6'>{sidebarTitle}</Typography>
              </Box>
            </IconButton>
            <Drawer
              anchor='left'
              open={open}
              onClose={toggleDrawer}
            >
              <SidebarComponent {...sidebarProps} />
            </Drawer>
          </>
        )}
        {SidebarComponent && !isMobile && (
          <>
            <Box sx={{ width: '18%', height: '100vh', overflowY: 'auto' }}>
              {SidebarComponent && <SidebarComponent {...sidebarProps} />}
            </Box>
          </>
        )}
        <Box
          sx={{
            width: isMobile || !SidebarComponent ? '100%' : '82%',
            height: '100vh',
            overflowY: 'auto',
          }}
        >
          {children}
        </Box>
      </Box>
    </>
  );
};

export default GlobalWrapper;
